export const AWARDS_NAME: { [key: string]: string } = {
    allAmerican: 'All-American',
    allConference: 'All-Conference',
    allPro: 'All-Pro',
    'Bronco Nagurski': 'Bronco Nagurski',
    'Butkus Award': 'Butkus',
    'CGS Showcase': 'CGS Showcase',
    'Chuck Bednarik': 'Chuck Bednarik',
    'Dave Rimington': 'Dave Rimington Trophy',
    "Davey O'Brien": "Davey O'Brien",
    'Doak Walker': 'Doak Walker',
    'East West Shrine': 'East-West Shrine Bowl',
    'Fred Biletnikoff': 'Fred Biletnikoff',
    Heisman: 'Heisman Trophy',
    'Jim Thorpe': 'Jim Thorpe',
    'John Mackey': 'John Mackey',
    'Johnny Unitas Golden Arm Award': 'Johnny Unitas Golden Arm Award',
    Lombardi: 'Lombardi',
    'Lou Groza': 'Lou Groza',
    'Maxwell Award': 'Maxwell Award',
    'Outland Trophy': 'Outland Trophy',
    proBowl: 'Pro Bowl',
    'Ray Guy': 'Ray Guy',
    'Senior Bowl': 'Senior Bowl',
    'Ted Hendricks': 'Ted Hendricks',
    'Walter Camp': 'Walter Camp',
};